// eslint-disable-next-line import/no-anonymous-default-export
     
export default "https://api.ecombo.co"; 
// export default "http://127.0.0.1:8000"; 
// export default "http://192.168.1.36:8000"; 
